import React from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

interface SortableHeaderProps<T extends string> {
  label: string;
  field: T;
  sortBy: T;
  sortOrder: 'asc' | 'desc';
  onSort: (field: T) => void;
}

export function SortableHeader<T extends string>({
  label, field, sortBy, sortOrder, onSort,
}: SortableHeaderProps<T>) {
  const active = sortBy === field;
  return (
    <button
      onClick={() => onSort(field)}
      style={{
        display: 'flex', alignItems: 'center', gap: '0.25rem',
        background: 'none', border: 'none', cursor: 'pointer', padding: 0,
        fontSize: 'var(--text-xs)', fontWeight: 600,
        color: active ? 'var(--color-primary)' : 'var(--color-text-muted)',
        textTransform: 'uppercase', letterSpacing: '0.05em',
        transition: 'color var(--transition-interactive)',
      }}
    >
      {label}
      {active
        ? (sortOrder === 'asc' ? <ChevronUp size={11} /> : <ChevronDown size={11} />)
        : <ChevronDown size={11} style={{ opacity: 0.3 }} />}
    </button>
  );
}
